import React from 'react';
import classNames from 'classnames';

import './ProductsContainer.module.scss';

const ProductsContainer = ({ isMobile, children }) => (
  <div styleName={classNames('container', { mobile: isMobile })}>
    { React.Children.map(children, child => <div styleName="item">{child}</div>) }
  </div>
);

export default ProductsContainer;


// WEBPACK FOOTER //
// ./src/js/widgets/Products/ProductsContainer.js